import React, { Component } from 'react'
import Auth from '../Auth'
import Row from '../Shared/Row'
import Column from '../Shared/Column'
import { inject, observer } from 'mobx-react'
import auth0 from 'auth0-js'
import Link from 'gatsby-link'

@inject('store')
@observer
class Authenticator extends Component {
	constructor() {
		super()
		this.state = {
			authSetup: false
		}
	}
	componentDidMount() {
		this.auth = new Auth()
		this.setState({
			authSetup: true
		})

		let token = localStorage.access_token
		if (token) {
			this.auth0Manage = new auth0.Management({
				domain: 'auth.globalcitizenyear.org',
				token: token
			})
		}
	}

	login() {
		this.auth.login()
	}

	signup() {
		this.auth.signup()
	}

	logout() {
		// saves user data, then logs out
		this.saveData()
	}

	saveData() {
		// save data here before logging out
		this.userId = JSON.parse(localStorage.user_info).sub
		if (localStorage.user_meta) {
			const userMeta = JSON.parse(localStorage.user_meta)
			// console.log(userMeta)
			if (this.auth0Manage && this.userId && userMeta) {
				this.auth0Manage.patchUserMetadata(this.userId, userMeta, err => {
					this.auth.logout()
				})
			} else {
				this.auth.logout()
				console.error('no user data to save or no account exists')
			}
		} else {
			this.auth.logout()
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			this.props.forceLogout != prevProps.forceLogout &&
			this.props.forceLogout == true
		) {
			alert(
				'Looks like something went wrong with your internet connection. Please log back in and try again.'
			)
			this.auth.logout()
		}
	}

	render() {
		const userName = this.props.store.userName
		return (
			<span>
				{this.state.authSetup && (
					<div
						id="inner-application"
						className="no-top-padding no-bottom-padding"
					>
						{!this.auth.isAuthenticated() && (
							<span>
								<Row
									className="no-padding form-contacts"
									style={{ paddingBottom: 0 }}
								>
									<Column width="12">
										<h5 className="section-title offset">Your Account</h5>
										{/*<img src={ `/icons/icon-account.svg` } alt="Global Citizen Year - Account Icon" className="icon" /> */}
									</Column>
								</Row>
								<Row className="no-padding app-login">
									<Column
										width="6"
										className="half-col"
										style={{ paddingTop: 0 }}
									>
										<h3>Create An Account</h3>
										<p>Create an account to start your application:</p>
										<p className="button" onClick={() => this.signup()}>
											Create Account
										</p>
									</Column>
									<Column
										width="6"
										className="half-col"
										style={{ paddingTop: 0 }}
									>
										<h3>Login Here</h3>
										<p>Already begun your application? Login here:</p>
										<p className="button" onClick={() => this.login()}>
											Login
										</p>
									</Column>
								</Row>
								<Row
									className="no-side-padding"
									style={{ paddingBottom: 0, paddingTop: 0 }}
								>
									<Column width="12">
										<h3>
											<strong>Are you eligible to apply?</strong>
										</h3>
										<p>The Global Citizen Year application is for:</p>
										<ul>
											<li>
												<strong>Current high school seniors.</strong>
												<em>
													{' '}
													(If you are a younger student,{' '}
													<Link to="/interest-form">sign up here</Link> and
													we'll let you know when the application opens for your
													year!)
												</em>
											</li>
											<li>
												<strong>
													U.S. citizens and/or students graduating from a United
													World College high school.
												</strong>
												<em>
													{' '}
													(Other international students can apply, but we cannot
													offer financial aid.)
												</em>
											</li>
										</ul>
									</Column>
								</Row>
							</span>
						)}
						{this.auth.isAuthenticated() && (
							<div>
								<a className="logout fixed" onClick={() => this.logout()}>
									Logout
								</a>
							</div>
						)}

						{this.props.children(this.auth.isAuthenticated())}
					</div>
				)}
				{!this.state.authSetup && <Row id="inner-application" />}
			</span>
		)
	}
}

export default Authenticator



// WEBPACK FOOTER //
// ./src/components/AppAuthentication/index.js